import axios from 'axios';
import { API_URL } from '../config/api';
import {
  deleteRealmDoc,
  readAppointmentsFromRealm,
  upsertRealmDocs,
} from '../realm/syncService';

const getHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    Authorization: token ? `Bearer ${token}` : '',
    'Content-Type': 'application/json',
  };
};

const persistAppointments = async (docs) => {
  const list = Array.isArray(docs) ? docs : docs ? [docs] : [];
  if (!list.length) return;
  try {
    await upsertRealmDocs('Appointment', list);
  } catch {
    // Realm is Electron-only; ignore in browser
  }
};

export const fetchAvailability = async ({ channelId, from, to } = {}) => {
  const response = await axios.get(`${API_URL}/calendar/availability`, {
    params: { channelId, from, to },
    headers: getHeaders(),
  });
  return response.data;
};

export const createAvailability = async (payload) => {
  const response = await axios.post(`${API_URL}/calendar/availability`, payload, {
    headers: getHeaders(),
  });
  return response.data;
};

export const deleteAvailability = async (id) => {
  const response = await axios.delete(`${API_URL}/calendar/availability/${id}`, {
    headers: getHeaders(),
  });
  return response.data;
};

export const fetchAppointments = async ({ channelId, from, to } = {}) => {
  try {
    const response = await axios.get(`${API_URL}/calendar/appointments`, {
      params: { channelId, from, to },
      headers: getHeaders(),
    });
    const data = response.data;
    await persistAppointments(data);
    return data;
  } catch (err) {
    const local = await readAppointmentsFromRealm({ channelId, from, to });
    if (local?.length) return local;
    throw err;
  }
};

export const createAppointment = async (payload) => {
  const response = await axios.post(`${API_URL}/calendar/appointments`, payload, {
    headers: getHeaders(),
  });
  await persistAppointments(response.data);
  return response.data;
};

export const updateAppointment = async (id, payload) => {
  const response = await axios.patch(
    `${API_URL}/calendar/appointments/${id}`,
    payload,
    { headers: getHeaders() },
  );
  await persistAppointments(response.data);
  return response.data;
};

export const updateAppointmentStatus = async (id, status) => {
  const response = await axios.patch(
    `${API_URL}/calendar/appointments/${id}/status`,
    { status },
    { headers: getHeaders() },
  );
  await persistAppointments(response.data);
  return response.data;
};

export const respondToAppointment = async (id, status) => {
  const response = await axios.patch(
    `${API_URL}/calendar/appointments/${id}/rsvp`,
    { status },
    { headers: getHeaders() },
  );
  await persistAppointments(response.data);
  return response.data;
};

export const deleteAppointment = async (id) => {
  const response = await axios.delete(`${API_URL}/calendar/appointments/${id}`, {
    headers: getHeaders(),
  });
  try {
    if (id) await deleteRealmDoc('Appointment', id);
  } catch {
    // ignore
  }
  return response.data;
};
